export default function () {
    return {
        restrict: 'A',
        require: '^tabset',
        link: function link(scope, elm, attrs) {
            var tab = scope.$eval(attrs.tabContentTransclude);

            // Now our tab is ready to be transcluded: both the tab heading area
            // and the tab content area are loaded.  Transclude 'em both.
            tab.$transcludeFn(tab.$parent, function (contents) {
                angular.forEach(contents, function (node) {
                    if (isTabHeading(node)) {
                        // Let tabHeadingTransclude know.
                        tab.headingElement = node;
                    } else {
                        elm.append(node);
                    }
                });
            });
        }
    };

    function isTabHeading(node) {
        return node.tagName && (node.hasAttribute('tab-heading') || node.hasAttribute('data-tab-heading') || node.tagName.toLowerCase() === 'tab-heading' || node.tagName.toLowerCase() === 'data-tab-heading');
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/tabs/directives/TabContent.js
// module id = 1155
// module chunks = 0